import { render, staticRenderFns } from "./AdsterraBanner.vue?vue&type=template&id=48008e82&scoped=true"
import script from "./AdsterraBanner.vue?vue&type=script&lang=js"
export * from "./AdsterraBanner.vue?vue&type=script&lang=js"
import style0 from "./AdsterraBanner.vue?vue&type=style&index=0&id=48008e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Viberary/repos/viberary-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48008e82",
  null
  
)

export default component.exports